import { preferencesActions } from '../../actions/preferencesActions';
import { CAPTIONS_ENABLED_KEY, TTS_SETTINGS_KEY } from '../../constants';
import { AppStore } from '../models/Store';
import { Dispatch, Middleware, MiddlewareAPI } from '@reduxjs/toolkit';

// TODO types
export const storageMiddleware: Middleware = ({ getState }: MiddlewareAPI<Dispatch, AppStore>) => {
  return (next: any) =>
    (action: any): any => {
      next(action);
      switch (action.type) {
        case preferencesActions.Captions_Enable:
        case preferencesActions.Captions_Disable:
          localStorage.setItem(CAPTIONS_ENABLED_KEY, `${getState().preferences.captionsEnabled}`);
          break;
        case preferencesActions.TTSSettings_Set:
          localStorage.setItem(TTS_SETTINGS_KEY, `${JSON.stringify(getState().preferences.ttsSettings)}`);
          break;
      }
    };
};

export const loadPersistedState = (key: string) => {
  const value = localStorage.getItem(key);
  return value;
};
